import { ALL_CHARTGROUPS } from "@/app/types"
import { SVG_GRAFFY_F_BW } from "@/pages/graffy/components/chatbot_svgs"
import {
  Binoculars,
  ChartLineUp,
  Database,
  House,
  MapTrifold,
  Pulse,
} from "@phosphor-icons/react"
import { ReactNode } from "react"

export interface MenuItem {
  id: string
  name: string
  url: string | null
  icon?: (props: React.SVGProps<SVGSVGElement>) => ReactNode
  children?: {
    id: string
    name: string
    url: string
    chartCode?: string
  }[]
}

export function getNavigationMenuOptions(): MenuItem[] {
  return [
    {
      id: "home",
      name: "Home",
      url: "/home",
      icon: () => <House className="h-5 w-5" weight="fill" />,
    },
    {
      id: "workspace",
      name: "Workspace",
      url: null,
      icon: Database,
      children: [
        {
          id: "lists",
          name: "Lists",
          url: "/lists",
        },
        {
          id: "notes",
          name: "Notes",
          url: "/notes",
        },
        {
          id: "teams",
          name: "Teams",
          url: "/organization/teams",
        },
        {
          id: "organization",
          name: "Organization",
          url: "/organization",
        },
      ],
    },
    {
      id: "explore",
      name: "Explore",
      url: "/charts",
      icon: MapTrifold,
      children: ALL_CHARTGROUPS.map((chartGroup) => {
        return {
          id: chartGroup.slug,
          name: chartGroup.groupname,
          url: "/charts",
          chartCode: chartGroup.charts[0].code,
        }
      }),
    },
    {
      id: "monitor",
      name: "Monitor",
      url: "/monitor",
      icon: () => <Binoculars weight="fill" className="h-5 w-5" />,
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          url: "/dashboard",
        },
        {
          id: "growth-gauge",
          name: "Growth Gauge",
          url: "/monitor/growth-gauge",
        },
        {
          id: "asset-momentum",
          name: "Asset Momentum",
          url: "/monitor/asset-momentum",
        },
        {
          id: "percentile-tracker",
          name: "Percentile Tracker",
          url: "/monitor/percentile-tracker",
        },
        {
          id: "asset-mix",
          name: "Asset Mix",
          url: "/monitor/asset-mix",
        },
        {
          id: "competitive-positioning",
          name: "Competitive Positioning",
          url: "/monitor/competitive-positioning",
        },
        {
          id: "leaders-laggards",
          name: "Leaders & Laggards",
          url: "/monitor/leaders-laggards",
        },
      ],
    },
    {
      id: "grow",
      name: "Grow",
      url: "/grow",
      icon: ChartLineUp,
      children: [
        {
          id: "general-sales",
          name: "Generate Sales",
          url: "/grow/generate-sales",
        },
        {
          id: "optmize-products",
          name: "Optimize Products",
          url: "/grow/optimize-products",
        },
        {
          id: "reward-talent",
          name: "Reward Talent",
          url: "/grow/reward-talent",
        },
      ],
    },
    {
      id: "pulse",
      name: "Pulse",
      url: "/pulse",
      icon: () => <Pulse weight="fill" className="h-5 w-5" />,
    },
    {
      id: "graffy",
      name: "Graffy",
      url: "/graffy",
      icon: SVG_GRAFFY_F_BW,
    },
  ]
}
